import script from "./baseBlock.vue?vue&type=script&lang=ts"
export * from "./baseBlock.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__